<template>
  <section>
    <v-btn color="primary" dark @click.stop="dialog = true">
      Adicionar Documento
    </v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-form v-model="valid">
          <v-card-title class="headline green darken-2 white--text">
            Adicionar Documentos
          </v-card-title>
          <v-card-text>
              <v-autocomplete
                :items="documentTypes"
                :search-input.sync="search"
                @change="selectDocumentType"
                label="Selecione um Documento"
                no-data-text="Nenhum resultado encontrado"
                :item-text="name"
                item-value="id"
                clearable
                return-object></v-autocomplete>

                <v-data-table
                  v-if="selectedDocumentTypes.length > 0"
                  :headers="headers"
                  :items="selectedDocumentTypes"
                  hide-actions
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.code }}</td>
                    <td>{{ props.item.name }}</td>
                    <td>
                      <v-btn icon
                          @click="removeDocumentType(props.item.id)">
                          <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="dialog = false; selectedDocumentTypes = []">Cancelar</v-btn>
            <v-btn color="primary" :disabled="!selectedDocumentTypes.length" flat @click="AddDocumentType()">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>

import DocumentTypeService from '@/services/applications/configurations/DocumentTypeService';
import ChecklistService from '@/services/applications/configurations/ChecklistService';
import validationRules from '@/mixins/validation-rules';

export default {
  name: 'AddDocumentTypeToChecklist',
  components: {},
  props: ['checklist'],
  mixins: [validationRules],
  mounted() {
    DocumentTypeService
      .fetchDocumentTypes()
      .then(({ data }) => {
        this.documentTypes = data.document_types;
      });
  },
  data() {
    return {
      requiredRules: [validationRules.required],
      dialog: false,
      valid: false,
      documentTypes: [],
      selectedDocumentTypes: [],
      search: null,
      headers: [
          { text: 'Código', value: 'code', sortable: false, align: 'center' },
          { text: 'Nome', value: 'name', sortable: false, align: 'center' },
          { text: 'Ações', value: 'actions', sortable: false, align: 'center' }],
    };
  },
  methods: {
    AddDocumentType() {
      const vm = this;
      ChecklistService
        .addDocumentType(vm.checklist.id,
          vm.selectedDocumentTypes.map((item) => { return item.id }))
        .then((response) => {
          vm.$swal({
            title: 'Documentos adicionados ao checklist.',
            text: '',
            type: response.data.create_all_document_types ? 'success' : 'info',
            confirmButtonText: 'Ok',
          }).then(() => {
            ChecklistService.list(vm.checklist.id)
              .then((resp) => {
                vm.$emit('document-type-added', resp.data);
                vm.dialog = false;
              });
          });
        })
        .catch((error) => {
          vm.$swal({
            title: 'Erro',
            text: error.response.data.join('\n'),
            type: 'error',
            showConfirmButton: 'Ok',
          });
        });

        vm.selectedDocumentTypes = [];
    },
    selectDocumentType(val) {
      const vm = this;
      if(!vm.selectedDocumentTypes.some(item => item.id === val.id))
        vm.selectedDocumentTypes.push(val);
    },
    removeDocumentType(id) {
      this.selectedDocumentTypes = this.selectedDocumentTypes.filter((item) => item.id != id);
    },
    name(item) {
      return item.code + ' - ' + item.name;
    },
  },
  watch: {
    search(val) {
      if(val === null) return;
      DocumentTypeService
        .all({
          q: val
        })
        .then(({ data }) => {
          this.documentTypes = data.document_types;
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
